import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form';
import {renderTextField, renderTextArea} from '../common/RenderFields'
import _ from 'lodash'
import Load from '../Load'

class SupportForm extends Component {

    render() {
        const { handleSubmit } = this.props;

        //console.log('SupportForm', this.props)

        return (
            <form className="my-form" onSubmit={handleSubmit}>

                <div className="my-section">
                    <Field name="name" label="Name" component={renderTextField} />
                    <Field name="email" label="Email" component={renderTextField} />
                    <Field name="subject" label="Subject" component={renderTextField} />
                    <Field name="body" label="Message" component={renderTextArea} />
                </div>

                <div className="my-section" style={{borderBottom: 'dashed 0px #ccc'}}>
                    <button className="submit" type="submit">Submit</button>
                    <button className="link" onClick={this.props.close}>Return to app</button>
                </div>

                {(this.props.loading || {}).sendSupportMessage && <Load/>}
            </form>
        );
    }
}

const validate = (values) => {
    const errors = {}

    _.forEach([
        'name',
        'email',
        'subject',
        'body'], k => {
        if (!values[k]) {
            errors[k] = 'Required'
        }
    })

    //console.log('errors', errors)
    return errors
}

SupportForm = reduxForm({
    form: 'SupportForm',
    validate
})(SupportForm);

SupportForm = connect((state,props) => {
    return {}
})(SupportForm)

export default SupportForm




// WEBPACK FOOTER //
// ./src/components/support/SupportForm.jsx